import React, { useEffect } from 'react'
import { useRef } from 'react';
import{Link,useLocation} from 'react-router-dom'
import './header.scss'
import logo from '../header/logo2.png'

// const screenSize=window.innerWidth;

const headerNav=[
    
  {
    display:"Home",
  path:"/"
},
{
  display:"Movies",
  path:"/movie"
},
{
  display:"TV Series",
  path:"/tv"
},
];
const Header = () => {
  // const[screenSize,setScreenSize]=useState(window.innerWidth);
  const { pathname }=useLocation();
  const headerRef=useRef(null);
  const active=headerNav.findIndex(e=>e.path===pathname);
  useEffect(()=>{
    const shrinkHeader=()=>{
      if(document.body.scrollTop>100||document.documentElement.scrollTop>100){
        headerRef.current.classList.add('shrink');
      }
      else{
        headerRef.current.classList.remove('shrink');          
      }
    }
    window.addEventListener("scroll",shrinkHeader);
    return()=>{
      window.removeEventListener("scroll",shrinkHeader);
    };
  },[])
  return (
    <div ref={headerRef} className="header">
      <div className="header__wrap container">
        <div className='logo'>
          
          <Link to="/"><img src={logo} alt="" style={{filter:"invert(1)"}} /></Link>
        </div>
        <ul className="header__nav">
          {
            headerNav.map((e,i)=>(
              <li key={i} className={`${i===active?"active":""}`}>
                <Link to={e.path}>
                  {e.display}
                </Link>
              </li>
            ))
          }
        </ul>
      </div>
    </div>
  )
}

export default Header
